// Enable B2B from ?b2b / disable from ?b2c as soon as script loads
(function() {
    try {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('b2c')) {
            window.localStorage.setItem('customerType', 'consumer');
            window.localStorage.setItem('isBulkOrder', 'false');
        } else if (urlParams.has('b2b')) {
            window.localStorage.setItem('customerType', 'business');
        }
    } catch (_) {}
})();

/**
 * If URL has "b2b", enables B2B mode; if "b2c", disables it. Then returns whether B2B mode is active.
 */
function getIsB2BMode() {
    try {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('b2c')) {
            window.localStorage.setItem('customerType', 'consumer');
            window.localStorage.setItem('isBulkOrder', 'false');
            return false;
        }
        if (urlParams.has('b2b')) {
            window.localStorage.setItem('customerType', 'business');
        }
        var customerType = window.localStorage.getItem('customerType');
        var bulkOrder = window.localStorage.getItem('isBulkOrder');
        return customerType === 'business' || bulkOrder === 'true';
    } catch (_) {
        return false;
    }
}

/**
 * Keep ?b2b in the URL when localStorage B2B is on.
 */
function ensureB2BUrlParam() {
    try {
        var isB2B = getIsB2BMode();
        var url = new URL(window.location.href);
        if (isB2B) {
            if (!url.searchParams.has('b2b')) {
                url.searchParams.set('b2b', '1');
            }
            url.searchParams.delete('b2c');
            window.history.replaceState({}, '', url.toString());
        } else if (url.searchParams.has('b2b')) {
            url.searchParams.delete('b2b');
            window.history.replaceState({}, '', url.toString());
        }
    } catch (_) {}
}

/**
 * Sync localStorage B2B mode to cart attributes so Liquid can read it.
 */
function syncB2BModeToCartAttribute() {
    try {
        if (!window.Shopify || !Shopify.routes || !Shopify.routes.root) return;
        var isB2B = getIsB2BMode();
        var desired = isB2B ? 'true' : '';
        if (window.__b2bCartAttrSynced === desired) return;
        window.__b2bCartAttrSynced = desired;
        fetch(`${Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ attributes: { b2b_mode: desired } })
        }).catch(function() {});
    } catch (_) {}
}

/**
 * Keep hidden .custom-quantity-input in sync with visible quantity selector.
 */
function syncHiddenQuantityFromInput(input) {
    try {
        if (!input) return;
        var form = input.form;
        if (!form) {
            var formId = input.getAttribute('form');
            if (formId) form = document.getElementById(formId);
        }
        if (!form) return;
        var val = parseInt(input.value, 10);
        if (!val || val < 1) val = parseInt(input.min, 10) || 1;
        form.querySelectorAll('.custom-quantity-input').forEach(function(inp) { inp.value = val; });
    } catch (_) {}
}

document.addEventListener('input', function(e) {
    var target = e && e.target;
    if (target && target.classList && target.classList.contains('quantity-selector__input')) {
        syncHiddenQuantityFromInput(target);
    }
});

document.addEventListener('change', function(e) {
    var target = e && e.target;
    if (target && target.classList && target.classList.contains('quantity-selector__input')) {
        syncHiddenQuantityFromInput(target);
    }
});

/**
 * Updates the announcement bar B2B button href: when in B2B mode and a "when active" URL is set, use it; otherwise use the default B2B URL.
 */
function updateAnnouncementBarB2BButton() {
    var btn = document.querySelector('.announcement-bar__b2b-button');
    if (!btn) return;
    var defaultUrl = btn.getAttribute('data-b2b-url');
    var whenActiveUrl = btn.getAttribute('data-b2b-url-when-active');
    var isB2B = getIsB2BMode();
    var label = btn.querySelector('.announcement-bar__b2b-button-label');
    if (label) {
        label.textContent = isB2B ? 'B2C' : 'B2B';
    }
    if (isB2B && whenActiveUrl) {
        btn.setAttribute('href', whenActiveUrl);
    } else if (defaultUrl) {
        btn.setAttribute('href', defaultUrl);
    }
}

document.addEventListener('variant:change', function(event) {
    console.log('variant:change event fired');
    let variant = event.detail?.variant;
    // scroll to top of the page if display is not on mobile
    if (window.innerWidth > 1024) {
        window.scrollTo(0, 0);
    }

    const buyButtons = document.querySelectorAll('.buy-buttons');
    if (variant) {
        console.log('variant: ', variant);
        const variantPrice = variant.price;
        const variantPriceFormat = window.formatStoreCurrency ? window.formatStoreCurrency(variantPrice) : (variantPrice / 100).toFixed(2);

        buyButtons.forEach((button) => {
            const realButton = button.querySelector('button');
            if (realButton.disabled) {
                console.log('button is disabled');
                const preselectQty = document.querySelectorAll('.cstm-qck-buy-con .preselect-qty-itm.active');
                if (preselectQty.length > 0) {
                    preselectQty.forEach((qty) => {
                        const dscntPrice =  qty.querySelector('.preselect-qty-itm-price .preselect-qty-itm-discount-price').textContent;
                        console.log('dscntPrice: ', dscntPrice);
                        const addToCartText = button.closest('[data-add-to-cart-text]')?.getAttribute('data-add-to-cart-text');
                        button.innerHTML = `
                        <button type="submit" class="button button--lg button--subdued" is="custom-button"><div>${addToCartText} · <span id="product-price-${variant.id}" class="price-label" name="price">${dscntPrice}</span></div><span class="button__loader">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span></button>`;
                    });
                }
            
            }

        });

    } else {
        console.log('variant is not available');

        buyButtons.forEach((button) => {
            const isQuickBuy = button.getAttribute('data-is-quick-buy') === 'true';
            if (isQuickBuy) {
                const btn = button.querySelector('button');
                btn.disabled = true;
                btn.innerHTML = 'Unavailable.';
            }
        })
    }

    const isB2BMode = getIsB2BMode();

    try {
        document.documentElement.classList.toggle('b2b-mode', isB2BMode);
    } catch (_) {}

    if (localStorage.getItem('isBulkOrder') === 'true') {
        document.querySelector('.product-info__quantity-selector').style.display = 'none';
    }


    const addToCartText = document.querySelector(".buy-buttons")

    if (addToCartText?.length) {
        if (variant) {
            if (variant.available) {
                // document.getElementById('klaviyo-bis-trigger').style.display = 'none';
            } else {
                // document.getElementById('klaviyo-bis-trigger').style.display = 'flex';
            }
        } 
    }

    // Gallery media switching is handled by theme.js _onSectionRerender + _onVariantChanged

    // dispatch custom event trigger preselect price update
    window.dispatchEvent(new CustomEvent('variant:changed'));
    
});

// Ensure b2b-mode class and announcement bar B2B button href are set on initial load
document.addEventListener('DOMContentLoaded', function() {
    try {
        var isB2BMode = getIsB2BMode();
        document.documentElement.classList.toggle('b2b-mode', isB2BMode);
        updateAnnouncementBarB2BButton();
        applyB2BCartDrawerCustomPricing();
        ensureB2BUrlParam();
        syncB2BModeToCartAttribute();
        document.querySelectorAll('.quantity-selector__input').forEach(syncHiddenQuantityFromInput);
    } catch (_) {}
});

// In localStorage-only B2B, force a drawer refresh after add
document.addEventListener('variant:add', function() {
    try {
        var isLocalB2B = getIsB2BMode() && document.body.getAttribute('data-customer-b2b') !== 'true';
        if (isLocalB2B) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
    } catch (_) {}
});

// Recalculate .custom-pricing in cart drawer to ex-VAT when in B2B mode
function applyB2BCartDrawerCustomPricing() {
    if (typeof getIsB2BMode !== 'function' || !getIsB2BMode()) return;
    var vatRate = parseInt(window.vatRates, 10) || 0;
    var vatDenom = 100 + vatRate;
    var drawer = document.querySelector('.cart-drawer');
    if (!drawer) return;
    var customPricings = drawer.querySelectorAll('.line-item .custom-pricing[data-unit-price-cents]');
    customPricings.forEach(function(div) {
        var cents = parseInt(div.getAttribute('data-unit-price-cents'), 10);
        var qty = div.getAttribute('data-quantity') || '1';
        if (isNaN(cents)) return;
        var exVatCents = Math.round(cents * 100 / vatDenom);
        var amount = exVatCents / 100;
        var formatted = window.formatStoreCurrencyDecimal ? window.formatStoreCurrencyDecimal(amount) : (amount.toFixed(2) + ' kr.');
        var p = div.querySelector('p');
        if (p) p.textContent = formatted + ' x ' + qty;
        var label = div.querySelector('.custom-pricing-ex-vat-label');
        if (!label) {
            label = document.createElement('span');
            label.className = 'custom-pricing-ex-vat-label text-sm text-subdued';
            var dataLabel = document.querySelector('[data-ex-vat-label]');
            label.textContent = (dataLabel && dataLabel.getAttribute('data-ex-vat-label')) || 'Ex VAT';
            div.appendChild(label);
        }
    });
}

document.addEventListener('cart:refresh', function() {
    setTimeout(applyB2BCartDrawerCustomPricing, 50);
});
document.addEventListener('cart:change', function() {
    setTimeout(applyB2BCartDrawerCustomPricing, 50);
});

// B2B quick order: use existing ATC button to add multiple variants
(function() {
    function getClosestScope(form) {
        return (
            form.closest('.shopify-section') ||
            form.closest('section') ||
            form.closest('main') ||
            document
        );
    }

    function hasB2BQuickOrder(scope) {
        if (!scope) return false;
        return !!scope.querySelector('.js-b2b-qty-row');
    }

    function collectB2BItems(scope) {
        var items = [];
        if (!scope) return items;
        scope.querySelectorAll('.js-b2b-qty-row').forEach(function(row) {
            var input = row.querySelector('.js-b2b-qty-input');
            if (!input || input.disabled) return;
            var qty = parseInt(input.value, 10);
            if (!qty || qty <= 0) return;
            var id = row.getAttribute('data-variant-id') || (row.dataset && row.dataset.variantId);
            if (!id) return;
            items.push({ id: Number(id), quantity: qty });
        });
        return items;
    }

    async function fetchCartJson() {
        var resp = await fetch(Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } });
        return await resp.json();
    }

    async function addItemsToCart(items) {
        var sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle }
        }));
        var firstVariantId = (items && items[0] && items[0].id) ? items[0].id : null;

        var resp = await fetch(Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                items: items,
                // When sending JSON, Shopify expects sections as an array (like cart/change.js)
                sections: sectionsToBundle,
                // Helps Shopify render the right section context (matches theme product-form behavior)
                sections_url: firstVariantId ? (Shopify.routes.root + 'variants/' + firstVariantId) : undefined
            })
        });

        var responseJson = await resp.json();
        if (!resp.ok) {
            throw responseJson;
        }

        var cart = await fetchCartJson();
        if (responseJson && responseJson.sections) {
            cart['sections'] = responseJson.sections;
        }

        return { responseJson: responseJson, cart: cart };
    }

    function resetB2BInputs(scope) {
        if (!scope) return;
        scope.querySelectorAll('.js-b2b-qty-input').forEach(function(input) {
            if (!input.disabled) input.value = 0;
        });
        // trigger recalculation in the variant-picker script
        try {
            scope.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (_) {}
    }

    document.addEventListener('submit', function(e) {
        try {
            var form = e.target;
            if (!form || form.tagName !== 'FORM') return;
            if (form.getAttribute('is') !== 'product-form') return;

            var scope = getClosestScope(form);
            if (!hasB2BQuickOrder(scope)) return;

            var items = collectB2BItems(scope);
            if (!items.length) return; // fallback to normal submit if nothing selected

            e.preventDefault();
            e.stopImmediatePropagation();

            var btn = form.querySelector('button[type="submit"]');
            if (btn) {
                btn.disabled = true;
                btn.classList.add('loading');
                btn.setAttribute('aria-busy', 'true');
            }

            addItemsToCart(items)
                .then(function(result) {
                    try {
                        var responseJson = result && result.responseJson ? result.responseJson : null;
                        var cart = result && result.cart ? result.cart : null;
                        if (cart) {
                            // Match theme behavior so cart drawer opens + updates
                            form.dispatchEvent(new CustomEvent('variant:add', {
                                bubbles: true,
                                detail: {
                                    items: (responseJson && Object.prototype.hasOwnProperty.call(responseJson, 'items')) ? responseJson.items : [responseJson],
                                    cart: cart
                                }
                            }));
                            // If we have section HTML, trigger cart:change (drawer updates from sections)
                            if (cart.sections && Object.keys(cart.sections).length) {
                                document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                                    bubbles: true,
                                    detail: { baseEvent: 'variant:add', cart: cart }
                                }));
                            } else {
                                // Fallback: force a full drawer refresh (drawer fetches section HTML itself)
                                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                            }
                        }
                    } catch (err) {
                        console.error(err);
                    }
                    resetB2BInputs(scope);
                })
                .catch(function(err) { console.error('B2B quick order add failed', err); })
                .finally(function() {
                    if (btn) {
                        btn.disabled = false;
                        btn.classList.remove('loading');
                        btn.removeAttribute('aria-busy');
                    }
                });
        } catch (err) {
            console.error(err);
        }
    }, true);
})();

// Preselect on PDP
class PreSelect extends HTMLElement {
    constructor() {
        super();
        this.customerType = window.localStorage.getItem('customerType');
        this.selected = window.localStorage.getItem('preselectedQty');
        this.isBulkOrderToggle = window.localStorage.getItem('isBulkOrder');
    }

    connectedCallback() {
        this.initializeElements();
        this.attachEvents();
    }

    initializeElements() {
        this.container = this.querySelector('.preselect-qty-con');
        this.itemContainer = this.querySelector('.preselect-qty-itm-con');
        this.$productQuantity = document.querySelector('.product-info__quantity-selector');

        if (this.customerType === 'consumer' && this.isBulkOrderToggle === 'false') {
            this.style.display = 'block';
        }

        if (this.selected) {
            this.itemContainer.querySelectorAll('.preselect-qty-itm').forEach((item) => {
                if (item.dataset.qty === this.selected) {
                    item.classList.add('active');
                    this.$productQuantity.querySelector('input').value = this.selected;
                } else {
                    item.classList.remove('active');
                }
            });
            
            // update add cart price
            this.updateAddCartPrice();
        }
    }

    attachEvents() {
        this.itemContainer.addEventListener('click', (e) => {
            const target = e.target.closest('.preselect-qty-itm');
            if (target) {
                this.itemContainer.querySelectorAll('.preselect-qty-itm').forEach((item) => {
                    item.classList.remove('active');
                });
                target.classList.add('active');
                this.dispatchEvent(new CustomEvent('preselect', {
                    detail: {
                        quantity: target.dataset.qty
                    }
                }));

                // update add cart price
                this.updateAddCartPrice();
            }
        });

        this.addEventListener('preselect', (e) => {
            this.$productQuantity.querySelector('input').value = e.detail.quantity;
            const qtyInput = document.querySelectorAll('.custom-quantity-input');
            console.log('value: ', this.$productQuantity.querySelector('input').value)
            window.localStorage.setItem('preselectedQty', e.detail.quantity);
            if (qtyInput.length > 0) {
                qtyInput.forEach((input) => {
                    input.value = e.detail.quantity;
                }
                );
            }

            // update add cart price
            this.updateAddCartPrice();
        });

        window.addEventListener('variant:changed', () => {
            // update add cart price
            this.updateAddCartPrice();
        })

        window.addEventListener('variant:refreshed', () => {
            console.log('variant:refreshed event fired');
            // update add cart price
            this.updateAddCartPrice();
        })

        window.addEventListener('bulkToggled', (e) => {
            if (e.detail.state) {
                this.style.display = 'none';
            } else {
                this.style.display = 'block';
            }
        });

        document.addEventListener('DOMContentLoaded', () => {
            // When B2B mode (localStorage), preselect is hidden and normal qty selector is shown – don't touch quantity input
            if (this.customerType === 'business') return;

            // reset preselected quantity
            window.localStorage.removeItem('preselectedQty');

            this.itemContainer.querySelectorAll('.preselect-qty-itm').forEach((item) => {
                if (item.dataset.qty == 1) {
                    item.classList.add('active');
                    if (this.$productQuantity) this.$productQuantity.querySelector('input').value = this.selected || 1;
                } else {
                    item.classList.remove('active');
                }
            });
            
            // update add cart price
            this.updateAddCartPrice();
            
        });
    }

    updateAddCartPrice() {
        const preselectCon = document.querySelector('.preselect-qty-con');
        const addCartPrice = document.querySelector('[id^="product-price-"]') || document.getElementById('product-price-');

        if (!addCartPrice) {
            if (preselectCon) preselectCon.style.display = '';
            return;
        }

        if (preselectCon) preselectCon.style.display = 'block';
        
        // get active item
        const activeItem = this.itemContainer && this.itemContainer.querySelector('.preselect-qty-itm.active');
        if (!activeItem) return;

        // get active item price
        const activeItemPrice = activeItem.querySelector('.preselect-qty-itm-price .preselect-qty-itm-discount-price');
        if (!activeItemPrice) return;
        const activeItemPriceText = activeItemPrice.textContent;

        // update add cart price
        addCartPrice.textContent = activeItemPriceText;

        const buttonPrices = document.querySelectorAll('.button-price');

        buttonPrices.forEach((buttonPrice) => {
            buttonPrice.textContent = activeItemPriceText;
        });

        // Update loyalty points displayed next to the selector (if present)
        try {
            const raw = (activeItemPriceText || '').replace(/[^0-9,\.\-]/g, '');
            const lastComma = raw.lastIndexOf(',');
            const lastDot = raw.lastIndexOf('.');
            let normalized;
            if (lastComma !== -1 && lastDot !== -1) {
                const decimalIndex = Math.max(lastComma, lastDot);
                const integerPart = raw.slice(0, decimalIndex).replace(/[\.,]/g, '');
                const fractionalPart = raw.slice(decimalIndex + 1);
                normalized = integerPart + '.' + fractionalPart;
            } else if (lastComma !== -1) {
                const integerPart = raw.slice(0, lastComma).replace(/[,\.]/g, '');
                const fractionalPart = raw.slice(lastComma + 1);
                normalized = integerPart + '.' + fractionalPart;
            } else if (lastDot !== -1) {
                const integerPart = raw.slice(0, lastDot).replace(/[,\.]/g, '');
                const fractionalPart = raw.slice(lastDot + 1);
                normalized = integerPart + '.' + fractionalPart;
            } else {
                normalized = raw.replace(/[,\.]/g, '');
            }
            const priceUnits = parseFloat(normalized || '0') || 0;
            const majorUnits = priceUnits > 1000 ? (priceUnits / 100) : priceUnits;
            const points = Math.floor(majorUnits) * 4;
            document.querySelectorAll('.loyalty-points-earn-value').forEach(function(el){ el.textContent = String(points); });
        } catch (_) {}
    }
}

customElements.define('pre-select', PreSelect);

// main collection pagination
document.addEventListener('click', function(e) {
    // check if this is button and has an id of collection-load-more
    if (!e.target.matches('#collection-load-more')) return;
    var collectionPagination = document.querySelector('.collection_pagination_id');
    var collectionHiddenCards = document.querySelectorAll('.product-hidden');
    collectionHiddenCards.forEach(function(card, index) {
        if (index < 15) {
            card.classList.remove('product-hidden');
            card.classList.remove('hidden');
        }
    });

    collectionHiddenCards = document.querySelectorAll('.product-hidden');

    if (collectionHiddenCards.length === 0) {
        document.querySelector('.custom-pagination').style.display = 'none';
        if (collectionPagination) {
            collectionPagination.classList.remove('hidden');
        }
    }
});


function loadProductRecommendationsIntoSection() { 
    console.log("product recommendation loaded...")
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".custom-product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.getAttribute("product"); 

    console.log('custom recommendation: ', productRecommendationsSection.getAttribute("product")); 
    console.log("product id: ", productId);
    // Read limit from data attribute
    var limit = 4;
    // Build request URL
    var requestUrl = `/recommendations/products?section_id=cart-drawer&limit="+limit+"&product_id=${productId}&intent=related`;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
    // console.log("recommendation response: ", request.response)
    if (request.status >= 200 && request.status < 300) { 
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".custom-product-recommendations").innerHTML;
        
    }
    };
    request.send();
};

window.addEventListener("revalidate:product-recommendations", function(event) {
    console.log("revalidate:product-recommendations event fired");
    loadProductRecommendationsIntoSection();
})

document.addEventListener("DOMContentLoaded", function() {
    loadProductRecommendationsIntoSection();
});




// Threshold bar interactions (moved from snippet)
  function tbConvertToDanishPrice(price) {
    return window.formatStoreCurrency ? window.formatStoreCurrency(price) : ((price / 100).toFixed(2) + ' kr.');
  }

  function onTBChange(e) {
    if (e.target.tagName !== 'SELECT') return;
    var item = e.target.closest('.tb-card');
    if (!item) return;
    try {
      var product = JSON.parse(item.getAttribute('data-product'));
      var selects = Array.from(item.querySelectorAll('select'));
      var selectedOptions = selects.map(function(select) { return select.value; });
      var selectedVariant = product.variants.find(function(variant) {
        return variant.options.every(function(opt, idx) { return opt === selectedOptions[idx]; });
      });
      if (!selectedVariant) return;

      item.setAttribute('data-selected-variant', selectedVariant.id);

      var variantImgs = item.querySelectorAll('.tb-variant-image');
      variantImgs.forEach(function(img) {
        img.classList.remove('active');
        if (String(img.getAttribute('data-id')) === String(selectedVariant.id)) {
          img.classList.add('active');
        }
      });

      var cta = item.querySelector('.tb-add-to-cart');
      if (cta) {
        if (selectedVariant.available) {
          cta.classList.remove('disabled');
          var addToCartText = cta.getAttribute('data-add-to-cart-text') || 'Tilføj til kurv';
          cta.textContent = addToCartText + ' · ' + tbConvertToDanishPrice(0);
        } else {
          cta.classList.add('disabled');
          cta.textContent = 'Udsolgt';
        }
      }

      var selectedOption = e.target.options[e.target.selectedIndex];
      var colorHex = selectedOption.getAttribute('data-value');
      var colorIndicator = e.target.parentElement.querySelector('.tb-color-indicator');
      if (colorIndicator) {
        colorIndicator.style.backgroundColor = colorHex || 'transparent';
      }
    } catch (err) {
      console.error(err);
    }
  }

  async function onTBAddToCart(e) {
    var ctaEl = e.target.closest('.tb-add-to-cart');
    if (!ctaEl) return;
    var item = ctaEl.closest('.tb-card');
    if (!item) return;
    try {
      var product = JSON.parse(item.getAttribute('data-product'));
      var selects = Array.from(item.querySelectorAll('select'));
      var selectedOptions = selects.map(function(select) { return select.value; });
      var selectedVariant = product.variants.find(function(variant) {
        return variant.options.every(function(opt, idx) { return opt === selectedOptions[idx]; });
      });
      if (!selectedVariant) {
        var preselectedId = item.getAttribute('data-selected-variant');
        if (preselectedId) {
          selectedVariant = product.variants.find(function(v) { return String(v.id) === String(preselectedId); });
        }
        if (!selectedVariant) {
          selectedVariant = product.variants[0];
        }
      }
      if (!selectedVariant) return;

      var itemsToAdd = [{ id: selectedVariant.id, quantity: 1 }];
      var sectionsToBundle = ['variant-added'];

      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

      var resp = await fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: itemsToAdd, sections: sectionsToBundle.join(',') })
      });
      var responseJson = await resp.json();
      if (resp.status === 200) {
        var cartContent = await (await fetch(Shopify.routes.root + 'cart.js')).json();
        cartContent['sections'] = responseJson['sections'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartContent } }));
      }
    } catch (err) {
      console.error(err);
    }
  }

  // Delegated listeners on document to survive re-renders
  document.addEventListener('change', function(e) {
    if (!e.target.closest('.tb-recommendation-container')) return;
    onTBChange(e);
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.tb-recommendation-container')) return;
    onTBAddToCart(e);
  });

  // Preload variant images when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    var tbContainer = document.querySelector('.tb-recommendation-container');
    if (!tbContainer) return;
    var items = tbContainer.querySelectorAll('.tb-card');
    items.forEach(function(li) {
      try {
        var product = JSON.parse(li.getAttribute('data-product'));
        (product.variants || []).forEach(function(v) {
          if (v.featured_image && v.featured_image.src) {
            var img = new Image();
            img.src = v.featured_image.src;
          }
        });
      } catch (e) {}
    });
  });




// Threshold gifts auto-removal when going below thresholds
(function() {
  function getThresholdHost() {
    return document.querySelector('custom-free-cart-item-bar');
  }

  async function fetchCartJson() {
    try { return await (await fetch(`${Shopify.routes.root}cart.js`)).json(); } catch(e) { return null; }
  }

  // Parse a threshold map string like "EUR:40,DKK:300,NOK:450" for the given currency.
  // Falls back to the pre-resolved data attribute value if no map or no match.
  function resolveThreshold(host, mapAttr, resolvedAttr) {
    var map = host.getAttribute(mapAttr) || '';
    var currency = (host.getAttribute('data-currency') || window.storeCurrency || '').toUpperCase();
    if (map.indexOf(':') !== -1 && currency) {
      var pairs = map.split(',');
      for (var i = 0; i < pairs.length; i++) {
        var kv = pairs[i].trim().split(':');
        if (kv[0].trim().toUpperCase() === currency) {
          return Number(kv[1].trim()) * 100 || 0;
        }
      }
      return 0;
    }
    return Number(host.getAttribute(resolvedAttr)) || 0;
  }

  function getHostData() {
    var host = getThresholdHost();
    if (!host) return null;
    return {
      freeShippingThreshold: resolveThreshold(host, 'data-threshold-map-free', 'data-free-shipping-threshold'),
      secondThreshold: resolveThreshold(host, 'data-threshold-map-second', 'data-second-threshold'),
      giftCardThreshold: resolveThreshold(host, 'data-threshold-map-gift', 'data-gift-card-threshold'),
      // Note: these attributes hold PRODUCT IDs (not variant IDs)
      freeGiftProductId: host.getAttribute('data-free-shipping-variant-id'),
      secondGiftProductId: host.getAttribute('data-second-variant-id'),
      giftCardProductId: host.getAttribute('data-gift-card-variant-id')
    };
  }

  function buildRemovalPolicy(data, cartTotal) {
    var productIds = [];
    var tags = [];
    if (!data) return { productIds: productIds, tags: tags };
    // Below gift card threshold -> remove gift_card
    if (data.giftCardProductId && cartTotal < data.giftCardThreshold) {
      productIds.push(String(data.giftCardProductId));
      tags.push('gift_card');
    }
    // Below second threshold -> remove second (and also gift_card, already handled above)
    if (data.secondGiftProductId && cartTotal < data.secondThreshold) {
      productIds.push(String(data.secondGiftProductId));
      tags.push('second');
    }
    // Below free shipping threshold -> remove free_shipping (and also others, already handled above)
    if (data.freeGiftProductId && cartTotal < data.freeShippingThreshold) {
      productIds.push(String(data.freeGiftProductId));
      tags.push('free_shipping');
    }
    return { productIds: productIds, tags: tags };
  }

  async function removeGiftsIfNeeded(cart) {
    var hostData = getHostData();
    if (!hostData) return;
    var cartTotal = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
    var policy = buildRemovalPolicy(hostData, cartTotal);
    if (policy.productIds.length === 0 && policy.tags.length === 0) return;

    // Collect line item updates: set quantity 0 for any line whose variant id matches a gift that should be removed
    var updates = {};
    (cart.items || []).forEach(function(item) {
      var vId = String(item.id);
      var pId = String(item.product_id);
      var isTaggedGift = false;
      try {
        var props = item.properties || {};
        var tag = props['thresholdGift'] || props.thresholdGift;
        if (tag && policy.tags.indexOf(String(tag)) !== -1) isTaggedGift = true;
      } catch (_) {}
      if (policy.productIds.indexOf(pId) !== -1 || isTaggedGift) updates[vId] = 0;
    });
    var updateIds = Object.keys(updates);
    if (updateIds.length === 0) return;

    try {
      var resp = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates })
      });
      var updatedCart = await resp.json();
      if (resp.status === 200) {
        // Re-dispatch cart change/refresh so drawer UI updates immediately
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:remove', cart: updatedCart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
      }
    } catch (e) { console.error(e); }
  }

  // Hook into cart events and also run on DOM ready
  // Use Impact theme events per docs
  document.addEventListener('cart:change', function(e) {
    var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
    if (cart) removeGiftsIfNeeded(cart);
  });

  document.addEventListener('variant:add', function(e) {
    var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
    if (cart) removeGiftsIfNeeded(cart);
  });

  document.addEventListener('line-item:change', function(e) {
    var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
    if (cart) removeGiftsIfNeeded(cart);
  });

  document.addEventListener('cart:refresh', async function() {
    var cart = await fetchCartJson();
    if (cart) removeGiftsIfNeeded(cart);
  });

  document.addEventListener('DOMContentLoaded', async function() {
    var cart = await fetchCartJson();
    if (cart) removeGiftsIfNeeded(cart);
  });
})();



// Shipping insurance: add item before checkout if checkbox selected
(function() {
    var isProcessingInsurance = false;

    function getShippingInsuranceCheckbox() {
        return document.getElementById('shipping-insurance');
    }

    function getInsuranceId() {
        var el = getShippingInsuranceCheckbox();
        if (!el) return null;
        var raw = el.getAttribute('data-product-id');
        if (!raw) return null;
        // Normalize to numeric string (theme may pass numeric as string)
        return String(raw).replace(/[^0-9]/g, '');
    }

    async function getCartJson() {
        try {
            var resp = await fetch(Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } });
            return await resp.json();
        } catch (_) {
            return null;
        }
    }

    async function syncInsuranceCheckboxWithCart(cart) {
        try {
            var checkbox = getShippingInsuranceCheckbox();
            if (!checkbox) return;
            var insuranceId = getInsuranceId();
            if (!insuranceId) return;

            var currentCart = cart;
            if (!currentCart) {
                currentCart = await getCartJson();
            }
            if (!currentCart) return;

            var present = Array.isArray(currentCart.items) && currentCart.items.some(function(item) {
                return String(item.id) === String(insuranceId) || String(item.product_id) === String(insuranceId);
            });
            checkbox.checked = !!present;
        } catch (_) {}
    }

    async function addInsuranceIfNeeded() {
        var checkbox = getShippingInsuranceCheckbox();
        if (!checkbox || !checkbox.checked) return { handled: false };

        var insuranceId = getInsuranceId();
        if (!insuranceId) return { handled: false };

        if (isProcessingInsurance) return { handled: true };
        isProcessingInsurance = true;
        try {
            var cart = await getCartJson();
            var alreadyInCart = false;
            try {
                alreadyInCart = Array.isArray(cart && cart.items) && cart.items.some(function(item) {
                    return String(item.id) === String(insuranceId) || String(item.product_id) === String(insuranceId);
                });
            } catch (_) {}

            if (alreadyInCart) {
                return { handled: true, added: false };
            }

            try {
                var addResp = await fetch(Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        items: [ { id: Number(insuranceId), quantity: 1 } ]
                    })
                });
                var addedOk = !!(addResp && addResp.ok);
                var updatedCart = null;
                try {
                    updatedCart = await (await fetch(Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })).json();
                } catch (_) {}
                if (addedOk && updatedCart) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: updatedCart } }));
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
                    try { checkbox.checked = true; } catch (_) {}
                    try { syncInsuranceCheckboxWithCart(updatedCart); } catch (_) {}
                    return { handled: true, added: true };
                }
            } catch (_) {}

            return { handled: true, added: false };
        } finally {
            isProcessingInsurance = false;
        }
    }

    async function removeInsuranceIfPresent() {
        var insuranceId = getInsuranceId();
        if (!insuranceId) return { handled: false };

        if (isProcessingInsurance) return { handled: true };
        isProcessingInsurance = true;
        try {
            var cart = await getCartJson();
            var present = false;
            try {
                present = Array.isArray(cart && cart.items) && cart.items.some(function(item) {
                    return String(item.id) === String(insuranceId) || String(item.product_id) === String(insuranceId);
                });
            } catch (_) {}

            if (!present) {
                return { handled: true, removed: false };
            }

            try {
                var resp = await fetch(Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({ updates: (function(){ var u = {}; u[String(insuranceId)] = 0; return u; })() })
                });
                var updatedCart = null;
                try {
                    updatedCart = await resp.json();
                } catch (_) {}
                if (resp && resp.status === 200 && updatedCart) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:remove', cart: updatedCart } }));
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updatedCart } }));
                    try { var cb = getShippingInsuranceCheckbox(); if (cb) cb.checked = false; } catch (_) {}
                    try { syncInsuranceCheckboxWithCart(updatedCart); } catch (_) {}
                    return { handled: true, removed: true };
                }
            } catch (_) {}

            return { handled: true, removed: false };
        } finally {
            isProcessingInsurance = false;
        }
    }

    // Toggle add/remove on checkbox change (delegated for drawer re-renders)
    document.addEventListener('change', function(e) {
        var target = e && e.target ? e.target : null;
        if (!target || target.id !== 'shipping-insurance') return;

        // Prevent rapid double toggles
        try { target.disabled = true; } catch (_) {}
        var action = target.checked ? addInsuranceIfNeeded() : removeInsuranceIfPresent();
        Promise.resolve(action).finally(function() {
            var cb = getShippingInsuranceCheckbox();
            if (cb) { try { cb.disabled = false; } catch (_) {} }
        });
    }, true);

    // Keep checkbox state in sync with cart contents
    document.addEventListener('DOMContentLoaded', function() {
        syncInsuranceCheckboxWithCart();
    });

    document.addEventListener('cart:change', function(e) {
        var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
        syncInsuranceCheckboxWithCart(cart);
    });

    document.addEventListener('line-item:change', function(e) {
        var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
        syncInsuranceCheckboxWithCart(cart);
    });

    document.addEventListener('variant:add', function(e) {
        var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
        syncInsuranceCheckboxWithCart(cart);
    });

    document.addEventListener('cart:refresh', function() {
        // cart drawer re-renders; fetch fresh cart and sync
        syncInsuranceCheckboxWithCart();
    });
})();

